import React from "react";
import AdminDashboard from "@/pages/dashboard/AdminDashboard";

const Admin = () => <AdminDashboard />;

export default Admin;
